<script>
  import { onMount } from "svelte";
  import { fade, fly } from "svelte/transition";
  import {
    surveyStore,
    resetSurvey,
    calculateRecommendation,
    recommendationStore
  } from "../../stores/surveyStore";
  import LoadingAnimation from "../LoadingAnimation.svelte";

  // Direct image imports for different seating types

  import balconyImg from '../../assets/images/balcony/balcony_1.jpg';
  import balcony2Img from '../../assets/images/balcony/balcony_2.jpg';
  import floorImg from '../../assets/images/floor/floor_1.png';
  import floor2Img from '../../assets/images/floor/floor_2.jpg';
  // Benefit/perk images
  import seatsImg from "../../assets/images/benefits/best_seats.png";
  import eventsImg from "../../assets/images/benefits/events.jpg";
  import foodImg from "../../assets/images/benefits/food.png";
  import interestImg from "../../assets/images/benefits/interest_free.png";
  import tixImg from "../../assets/images/benefits/tix_ex.png";

  let loading = true;
  // let recommendation = null;
  $: recommendation = $recommendationStore;
  console.log(recommendation)

  const attributionSuffix = "&utm_source=charge&utm_medium=web&utm_content=recommendationtool";

  function appendAttribution(url, suffix) {
    if (!url || typeof url !== 'string') return url; // Basic safety check
    const cleanSuffix = suffix.startsWith('&') ? suffix : '&' + suffix;
    if (url.includes('?')) {
      return url + cleanSuffix;
    } else {
      return url + '?' + cleanSuffix.substring(1);
    }
  }
  let error = null;
  const LOADING_DURATION = 3000;

  // Toggle for showing old pricing
  let showOldPricing = false; // set to false to hide old pricing

  // ===============================
  // EARLY BIRD COUNTDOWN
  // ===============================
  let countdownText = "";
  let showEarlyBirdCountdown = false;
  let countdownInterval = null;

  // March 1, 2026 @ 11:59:59 PM ET
  function getEarlyBirdEndDate() {
    // Date.UTC(year, monthIndex, day, hour, minute, second)
    return new Date(Date.UTC(2026, 2, 2, 4, 59, 59));
  }

  function updateCountdown() {
    const diff = getEarlyBirdEndDate().getTime() - Date.now();

    if (diff <= 0) {
      showEarlyBirdCountdown = false;
      clearInterval(countdownInterval);
      countdownInterval = null;
      return;
    }

    showEarlyBirdCountdown = false;

    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    countdownText = `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }

  // Define URLs for different recommendation types  
  const standardRepresentativeUrl = appendAttribution("https://cavaliers.formstack.com/forms/26_27_charge_nation_inquiry", attributionSuffix);
  const premiumRepresentativeUrl = appendAttribution("https://cavaliers.formstack.com/forms/26_27_charge_nation_inquiry", attributionSuffix);
  const premiumClubsUrl = appendAttribution("https://www.rocketarena.com/premium", attributionSuffix);
  const membershipUrl = appendAttribution("https://seatgeek.com/cleveland-charge-tickets", attributionSuffix);
  const fullMembershipUrl = appendAttribution("https://seatgeek.com/cleveland/series/35941001-0014-eb72-a971-08de3c04070a?performer_id=265663", attributionSuffix);

  // Pre-calculate frequently used attributed URLs
  $: attributedFaqUrl = appendAttribution("https://cleveland.gleague.nba.com/charge-nation", attributionSuffix);
  $: attributedBenefitsUrl = appendAttribution("https://cleveland.gleague.nba.com/charge-nation", attributionSuffix);

  // Use a computed property to determine which URL to use
  $: representativeBookingUrl = packageType === "Premium" ? premiumRepresentativeUrl : standardRepresentativeUrl;

    // Add this function to detect mobile devices based on screen width
  function isMobileDevice() {
    // This will run in the browser environment only
    if (typeof window === 'undefined') return false;
    
    // Common mobile breakpoint is 768px
    return window.innerWidth <= 768;
  }
  
  // Call button state
  let showCallButton = false;
  let callButtonTimer;
  
  // Then modify the existing call button visibility logic to include mobile check
  function updateCallButtonState() {
    // Show call button on mobile devices only (no time restrictions)
    showCallButton = isMobileDevice();
  }

  /**
   * Get the appropriate package link based on recommendation
   * @param {string|object} recommendationCode - The recommendation code or package name object
   * @returns {string} Link to the package or contact page
   */
  function getPackageLink(recommendationCode) {
    // Handle undefined or null input
    if (!recommendationCode) {
      console.error("No recommendation code provided to getPackageLink");
      return "https://seatgeek.com/cleveland-charge-tickets"; // Default ticket package page
    }

    // Extract just the package type (Quarter, Half, Full, Premium)
    let packageType = "";
    let level = "";

    // Handle different formats
    if (typeof recommendationCode === "string") {
      // Extract from string (Half / Full, etc.)
      const parts = recommendationCode.split(/[\s\/]/);
      packageType = parts[0]; // Half, Full
      if (parts.length > 1) {
        level = parts[parts.length - 1];
      }
    } else if (recommendationCode && recommendationCode.packageName) {
      // Handle when passing the full recommendation object
      const parts = recommendationCode.packageName.split(/[\s\/]/);
      packageType = parts[0]; // Half, Full
      if (parts.length > 1) {
        level = parts[parts.length - 1].replace("Plan", "").trim(); // Bowl, Courtside
      }
    }

    console.log("Extracted package type:", packageType);
    console.log("Extracted level:", level);

    // For Full and Premium packages, return the representative booking URL
    if (packageType === "Full" || packageType === "Courtside") {
      // Use representative booking URL based on package
      return packageType === "Courtside" ? premiumRepresentativeUrl : standardRepresentativeUrl;
    }


    // For other packages, return the appropriate SeatGeek URL
    const packageLinks = {
      Half:"https://seatgeek.com/cleveland-charge-tickets/ticket-packages",
      Full: "https://seatgeek.com/cleveland/series/35941001-0014-eb72-a971-08de3c04070a?performer_id=265663",
    };

    return packageLinks[packageType] || packageLinks["Half"]; // Default to Quarter if not found
  }

  /**
   * Get the appropriate images based on seating level
   * @param {string} level - The seating level (Lower, Club, Loudville, Premium)
   * @returns {Array} Array of image URLs
   */
  function getSeatingImages(level) {
    if (!level) {
      // Default to general arena images if no level specified
      return [balconyImg, floorImg];
    }

    // Normalize level name to handle different formats
    level = level.toLowerCase().trim();
    console.log('sastelevel');
    console.log(level);

    if (level.includes("bowl")) {
      return [balconyImg, balcony2Img];
    } else if (level.includes("courtside")) {
      return [floorImg, floor2Img];
    }

    // Default fallback
    return [balconyImg, floorImg,];
  }

  /**
   * Check if the package requires contacting a representative instead of direct purchase
   * @param {string} packageType - The package type (Quarter, Half, Full, Premium)
   * @returns {boolean} True if contact representative is required
   */
  function isContactRepPackage(packageType) {
    return packageType === "Full" || packageType === "Courtside";
  }

  /**
   * Get the summary text based on the recommendation
   * @param {Object} recommendation - The recommendation object
   * @returns {string} Summary text
   */
  function getSummaryText(recommendation) {
    if (!recommendation || !recommendation.details) return "";

    const packageType = recommendation.details.type; // Half, Full
    const level = recommendation.details.level; // Bowl, Courtside

    const summaries = {
      Half: {
        Bowl:
          "Step up your fandom with <b>12</b> games from our balcony level seating with fantastic views and energy!",
        Courtside:
          "Experience <b>12</b> great Charge games from our premium courtside seats with enhanced comfort and amenities!",
        default:
          "Elevate your fan experience with <b>12</b> Charge games and get <b>significant savings</b> over single-game pricing!",
      },
      Full: {
        Bowl:
          "Step up your fandom with <b>24</b> games from our balcony level seating with fantastic views and energy!",
        Courtside:
          "Experience <b>24</b> great Charge games from our premium courtside seats with enhanced comfort and amenities!",
        default:
          "Elevate your fan experience with <b>24</b> Charge games and get <b>significant savings</b> over single-game pricing!",
      },
    };

    // Lookup summary; fallback to default
    return (
      (summaries[packageType] && summaries[packageType][level]) ||
      summaries[packageType]?.default ||
      "Your personalized Charge Nation membership recommendation based on your preferences!"
    );
  }

  
  /**
   * Get the user's selected perks from the survey
   * @returns {Array} Array of selected perk IDs
   */
  function getSelectedPerks() {
    // Check all possible keys where perks might be stored
    const perksData =
      $surveyStore.perks ||
      $surveyStore.q7 ||
      $surveyStore.q10 ||
      $surveyStore["multi-choice-7"] ||
      $surveyStore["multi-select-7"] ||
      $surveyStore["multi-choice-10"] ||
      $surveyStore["multi-select-10"];

    if (!perksData) return [];

    // Handle different data formats
    if (Array.isArray(perksData)) {
      return perksData; // Already in the format we need
    } else if (typeof perksData === "object") {
      // Convert object format with boolean values to array of selected IDs
      return Object.entries(perksData)
        .filter(
          ([_, selected]) =>
            selected === true || selected === 1 || selected === "1",
        )
        .map(([id]) => id);
    } else if (typeof perksData === "string") {
      // Single selection as string
      return [perksData];
    }

    return [];
  }

  // Format phone number for display
  function formatPhoneNumber(phoneNumber) {
    // Remove any non-numeric characters
    const cleaned = phoneNumber.replace(/\D/g, '');
    
    // Format for display (e.g., (216) 555-1234)
    let display;
    if (cleaned.length === 10) {
      display = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    } else if (cleaned.length === 11 && cleaned[0] === '1') {
      display = `1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 11)}`;
    } else {
      display = phoneNumber; // Return original if invalid format
    }
    
    // Format for dialing (tel: protocol)
    const dialing = `tel:${cleaned}`;
    
    return { display, dialing };
  }

  // Phone number to use for the call button
  const phoneNumber = "2164202050"; // Cavs main phone number
  $: formattedPhone = formatPhoneNumber(phoneNumber);

  // Handle phone call tracking
  function handlePhoneCallClick(event) {
    // Phone call click handler
  }
  
  /**
 * Get the perk images for a given package type and level
 * @param {string} packageType - "Half" or "Full"
 * @param {string} level - "Bowl" or "Courtside"
 * @returns {Array} Array of perk objects { image, label }
 */
function getPerkImagesForPackage(packageType, level) {
  // Default empty label since you said you'll update them later
  const blankLabel = "";

  if (packageType === "Half" && level === "Bowl") {
    return [
      { image: tixImg, label: "Flexible Ticket Exchange Program"},
      { image: eventsImg, label: "Exclusive Events and Experiences"}, 
      { image: interestImg, label: "Flexible Payment Plans" }
    ];
  }

  if (packageType === "Half" && level === "Courtside") {
    return [
      { image: seatsImg, label: "Best seats at Public Hall"}, 
      { image: foodImg, label: "All-inclusive food, beer, wine and soft drinks"},
      { image: eventsImg, label: "Exclusive Events and Experiences" }, 
    ];
  }

  if (packageType === "Full" && level === "Bowl") {
    return [
      { image: tixImg, label: "Flexible Ticket Exchange Program"},
      { image: eventsImg, label: "Exclusive Events and Experiences" }, 
      { image: interestImg, label: "Flexible Payment Plans" }, 
    ];
  }

  if (packageType === "Full" && level === "Courtside") {
    return [
      { image: seatsImg, label: "Best seats at Public Hall" }, 
      { image: foodImg, label: "All-inclusive food, beer, wine and soft drinks"},
      { image: eventsImg, label: "Exclusive Events and Experiences" },
     
    ];
  }

  // fallback
  return [
    { image: tixImg, label: "Flexible Ticket Exchange Program"},
    { image: eventsImg, label: "Exclusive Events and Experiences"}, 
    { image: interestImg, label: "Flexible Payment Plans" }
  ];
}

  let resizeHandler;

  onMount(() => {
    console.log("ResultsPage mounted", $surveyStore);

    setTimeout(() => {
      try {
        const recommendationCode = calculateRecommendation($surveyStore);
        if (!recommendationCode || !recommendation) {
          throw new Error("Recommendation failed");
        }
        loading = false;
      } catch (err) {
        error = err.message;
        loading = false;
      }
    }, LOADING_DURATION);

    // Call button logic
    updateCallButtonState();
    callButtonTimer = setInterval(updateCallButtonState, 60000);

    resizeHandler = () => updateCallButtonState();
    window.addEventListener("resize", resizeHandler);

    // ===============================
    // START EARLY BIRD COUNTDOWN
    // ===============================
    updateCountdown();
    countdownInterval = setInterval(updateCountdown, 1000);

    // ===============================
    // CLEANUP
    // ===============================
    return () => {
      if (callButtonTimer) clearInterval(callButtonTimer);
      if (countdownInterval) clearInterval(countdownInterval);
      if (resizeHandler) window.removeEventListener("resize", resizeHandler);
    };
  });

  // // Function to handle retaking the survey
  function handleRetakeSurvey() {
    // Reset the survey data and go back to the beginning
    resetSurvey();
  }

  function handleReserveClick(event) {
  // Prevent the default navigation
  event.preventDefault();

  const targetHref = event.currentTarget.href;

  // Open in a new tab instead of changing the current location
  setTimeout(() => {
    window.open(targetHref, '_blank', 'noopener,noreferrer');
  }, 100);
}

function handleRepresentativeClick(event) {
  // Prevent the default navigation
  event.preventDefault();

  const targetHref = event.currentTarget.href;

  // Open in a new tab instead of changing the current location
  setTimeout(() => {
    window.open(targetHref, '_blank', 'noopener,noreferrer');
  }, 100);
}


  // Extract package type and level for current recommendation
  $: level = recommendation?.details?.level ?? "";
$: packageType = recommendation?.details?.type ?? "";

    console.log('saste - level')
    console.log(level)
    console.log('saste - package type')
    console.log(packageType)
  
  $: contactRepRequired = isContactRepPackage(packageType);
  $: seatingImages = getSeatingImages(level);
  $: summaryText = getSummaryText(recommendation);
  $: galleryImageLink = contactRepRequired 
        ? representativeBookingUrl 
        : appendAttribution(getPackageLink(recommendation), attributionSuffix);
  $: selectedPerks = getSelectedPerks();
  $: organizedPerks = getPerkImagesForPackage(packageType, level);

</script>

<div class="results-page">
  {#if loading}
    <div class="loading-container" in:fade={{ duration: 300 }}>
      <LoadingAnimation loadingDuration={LOADING_DURATION} />
      <p>Generating your personalized membership recommendation...</p>
    </div>
  {:else if error}
    <div class="error-container" in:fade={{ duration: 300 }}>
      <div class="error-icon">⚠️</div>
      <p>{error}</p>
      <div class="action-buttons">
        <button class="retry-button" on:click={handleRetakeSurvey}
          >Try <b>Again</b></button
        >
      </div>
    </div>
  {:else if recommendation}
    <div
      class="recommendation-container"
      in:fade={{ duration: 300, delay: 200 }}
    >
      <h1 in:fly={{ y: -20, duration: 500, delay: 300 }}>
        Your Personalized Recommendation
      </h1>

      <!-- Location images above the text -->
      <div class="image-gallery" in:fly={{ y: 20, duration: 500, delay: 400 }}>
        {#each seatingImages as image, i}
          <a 
            href={galleryImageLink}
            on:click={contactRepRequired ? handleRepresentativeClick : handleReserveClick}
            target="_blank"
            rel="noopener noreferrer"
            class="gallery-image {i > 0 ? 'hide-on-mobile' : ''}" 
            style="animation-delay: {i * 150}ms"
          >
            <img src={image} alt="Charge {level} experience" />
          </a>
        {/each}
      </div>

      
      <div
        class="recommendation-card"
        in:fly={{ y: 20, duration: 500, delay: 500 }}
      >
        {#if showEarlyBirdCountdown}
          <div class="early-bird-countdown">
            <span class="early-bird-label">Early Bird Ends in</span>
            <span class="early-bird-timer">{countdownText}</span>
          </div>
        {/if}


        <h2>{@html recommendation.packageName ? recommendation.packageName.replace(/\b[A-Z]+\b/g, '<b>$&</b>').replace(/\b\d+\b/g, '<b>$&</b>') : "Recommended Package"}</h2>
      
        <div class="recommendation-summary">
          <p>{@html summaryText}</p>
        </div>
      
        <div class="recommendation-details">
          <div class="detail-row">
            <div class="detail-label">Games</div>
            <div class="detail-value">
              {@html recommendation.details?.games ? recommendation.details.games.replace(/\b\d+\b/g, '<b>$&</b>').replace(/\b[A-Z]+\b/g, '<b>$&</b>') : "Multiple regular season games"}
            </div>
          </div>

          <div class="detail-row">
            <div class="detail-label">Pricing</div>
            <div class="detail-value">
              {#if recommendation.details?.gamePrice && recommendation.details?.seatPrice}
                <div class="pricing-display">
                  <span class="monthly-pricing">
                    {#if showOldPricing && recommendation.details?.oldGamePrice}
                      <span class="old-price">${recommendation.details.oldGamePrice}</span>
                    {/if}
                    <span class="current-price-number">${recommendation.details.gamePrice}</span>/per game
                  </span>
                  <span class="seat-pricing">
                    Or from 
                    {#if showOldPricing && recommendation.details?.oldSeatPrice}
                      <span class="old-price">${recommendation.details.oldSeatPrice}</span>
                    {/if}
                    <span class="current-price-number">${recommendation.details.seatPrice}</span> total per plan
                  </span>
                </div>
              {:else}
                Contact for pricing
              {/if}
            </div>
          </div>

          {#if recommendation.details?.savings}
            <div class="detail-row">
              <div class="detail-label">Savings</div>
              <div class="detail-value">{@html recommendation.details.savings.replace(/\d+%/g, '<b>$&</b>').replace(/\$[\d,\.]+/g, '<b>$&</b>').replace(/\b[A-Z]+\b/g, '<b>$&</b>').replace(/\b\d+\b/g, '<b>$&</b>')}</div>
            </div>
          {/if}

          <div class="detail-row added-value-row">
            <div class="detail-value">
              {recommendation.details?.addedValue}
            </div>
          </div>

        </div>
      
        <div class="action-buttons" in:fly={{ y: 20, duration: 500, delay: 600 }}>
          {#if packageType === "Full"}
            <!-- Full package with consistent CTAs -->
            <a
              href={fullMembershipUrl}
              on:click={handleReserveClick}
              target="_blank"
              rel="noopener noreferrer"
              class="primary-button"
            >
              Explore Availability and Pricing
            </a>
            
            <a
              href={representativeBookingUrl}
              on:click={handleRepresentativeClick}
              target="_blank"
              rel="noopener noreferrer"
              class="secondary-button"
            >
              Book time with Representative
            </a>
            
            <!-- Phone Call button - only shown during business hours -->
            {#if showCallButton}
              <a
                href={formattedPhone.dialing}
                on:click={handlePhoneCallClick}
                class="call-button"
              >
                <span class="call-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                  </svg>
                </span>
                <span class="call-text">
                  <span class="call-primary-text">Speak with a Representative Now</span>
                  <span class="call-phone-number">{formattedPhone.display}</span>
                </span>
              </a>
            {/if}
          {:else if contactRepRequired}
            <!-- Other contact required packages -->
            <a
              href={representativeBookingUrl}
              on:click={handleRepresentativeClick}
              target="_blank"
              rel="noopener noreferrer"
              class="primary-button"
            >
              Contact Us To Discuss Seating And Pricing
            </a>
            
            <!-- Phone Call button - only shown during business hours -->
            {#if showCallButton}
              <a
                href={formattedPhone.dialing}
                on:click={handlePhoneCallClick}
                class="call-button"
              >
                <span class="call-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                  </svg>
                </span>
                <span class="call-text">
                  <span class="call-primary-text">Speak with a Representative Now</span>
                  <span class="call-phone-number">{formattedPhone.display}</span>
                </span>
              </a>
            {/if}
          {:else}
            <!-- Quarter and Half packages use SeatGeek links -->
            <a
              href={appendAttribution(getPackageLink(recommendation), attributionSuffix)}
              on:click={handleReserveClick}
              target="_blank"
              rel="noopener noreferrer"
              class="primary-button"
            >
            Explore Deposits and other plan options
            </a>
        
            <a
              href={representativeBookingUrl}
              on:click={handleRepresentativeClick}
              target="_blank"
              rel="noopener noreferrer"
              class="secondary-button"
            >
              Book time with Representative
            </a>
            
            <!-- Phone Call button - only shown during business hours -->
            {#if showCallButton}
              <a
                href={formattedPhone.dialing}
                on:click={handlePhoneCallClick}
                class="call-button"
              >
                <span class="call-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                  </svg>
                </span>
                <span class="call-text">
                  <span class="call-primary-text">Speak with a Representative Now</span>
                  <span class="call-phone-number">{formattedPhone.display}</span>
                </span>
              </a>
              <div class="hours-note">Available until 5:30 PM EST today</div>
            {/if}
          {/if}
        </div>
      
          <div class="perks-section">
            <h3>Top benefits within membership</h3>
            <div class="perks-grid">
              {#each organizedPerks as perk, index}
                <div
                  class="perk-item"
                  in:fade={{
                    duration: 300,
                    delay: 600 + index * 100,
                  }}
                >
                  <div class="perk-image">
                    <a href={attributedBenefitsUrl} target="_blank" rel="noopener noreferrer">
                      <img src={perk.image} alt={perk.label} />
                    </a>
                  </div>
                  <div class="perk-label">{@html perk.label}</div>
                </div>
              {/each}
            </div>
          </div>
          <a 
            href={attributedBenefitsUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            class="benefits-link"
            in:fade={{ duration: 300, delay: 800 }}
          >
            Explore all benefits →
          </a>
      </div> <!-- This closes recommendation-card -->
      
      <div class="action-buttons" in:fly={{ y: 20, duration: 500, delay: 600 }}>
       
        <a
            href={attributedFaqUrl}
            target="_blank"
            rel="noopener noreferrer"
            class="tertiary-button"
          >          Go back to Charge-Nation
        </a>
        
      </div>
      
      <div class="success-message" in:fade={{ duration: 300, delay: 700 }}>
        <p>
          Your results have been sent to your email. Check your inbox for
          additional information and next steps!
        </p>
      </div>
    </div>
  {:else}
    <!-- Fallback for unexpected state where neither loading, error nor recommendation are set -->
    <div class="error-container" in:fade={{ duration: 300 }}>
      <div class="error-icon">⚠️</div>
      <p>An unexpected error occurred. Please try again.</p>
      <div class="action-buttons">
        <button class="retry-button" on:click={handleRetakeSurvey}
          >Try <b>Again</b></button
        >
      </div>
    </div>
  {/if}
</div>

<style>
  .results-page {
    width: 100%;
    max-width: none; /* Remove max-width constraint */
    margin: 0 auto;
    padding: 2rem;
  }

  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.9);
      opacity: 0.8;
    }
    100% {
      transform: scale(1.1);
      opacity: 1;
    }
  }

  .error-container {
    text-align: center;
    padding: 2rem;
  }

  .error-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
  }

  .retry-button {
    background-color: #6F263D;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 30px;
    font-size: 1rem;
    cursor: pointer;
    margin-top: 1.5rem;
  }

  .recommendation-container {
    text-align: center;
    width: 100%;
    max-width: none; /* Remove container constraints */
  }

  h1 {
    font-size: 2.5rem;
    color: #6F263D;
    margin-bottom: 2rem;
  }

  /* Full-width image gallery */
  .image-gallery {
    display: flex !important;
    flex-direction: row !important; 
    justify-content: center !important;
    align-items: center !important;
    gap: 15px !important;
    width: 100% !important;
    margin-bottom: 2.5rem !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    max-width: none !important;
    overflow: visible !important;
  }

  .gallery-image {
    width: 300px !important; /* Fixed width */
    height: 200px !important; /* Fixed height */
    flex: 0 0 auto !important;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    opacity: 0;
    animation: fadeIn 0.5s forwards;
    display: block; /* Ensure it's a block-level element */
    text-decoration: none; /* Remove default link styling */
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  .gallery-image:hover {
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }

  .gallery-image img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
  }

  .recommendation-card {
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    padding: 2rem;
    margin-bottom: 2rem;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }

  h2 {
    font-size: 1.8rem;
    color: #333;
    margin-bottom: 1rem;
    font-weight: 600;
  }

  /* New styles for summary section */
  .recommendation-summary {
    margin-bottom: 1.5rem;
    border-bottom: 1px solid #eee;
    padding-bottom: 1rem;
  }

  .recommendation-summary p {
    font-size: 1.1rem;
    line-height: 1.5;
    color: #555;
  }

  .recommendation-details {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-bottom: 1.5rem;
  }

  .detail-row {
    display: flex;
    text-align: left;
    border-bottom: 1px solid #eee;
    padding-bottom: 1rem;
  }

  .detail-label {
    flex: 0 0 30%;
    font-weight: 600;
    color: #666;
  }

  .detail-value {
    flex: 1;
    color: #333;
  }

  /* Phone call button styling */
  .call-button {
    display: flex;
    align-items: center;
    background-color: #00b359; /* Green color for call buttons */
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 30px;
    text-decoration: none;
    margin-top: 1rem;
    transition: all 0.2s ease;
    animation: pulse-green 2s infinite;
    box-shadow: 0 4px 8px rgba(0, 179, 89, 0.3);
  }
  
  @keyframes pulse-green {
    0% {
      box-shadow: 0 0 0 0 rgba(0, 179, 89, 0.4);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(0, 179, 89, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(0, 179, 89, 0);
    }
  }
  
  .call-button:hover {
    background-color: #009e4f;
    transform: translateY(-2px);
  }
  
  .call-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.75rem;
  }
  
  .call-text {
    display: flex;
    flex-direction: column;
  }
  
  .call-primary-text {
    font-weight: 600;
    font-size: 1rem;
  }
  
  .call-phone-number {
    font-size: 0.85rem;
    opacity: 0.9;
  }
  
  .hours-note {
    font-size: 0.8rem;
    color: #666;
    margin-top: 0.5rem;
    font-style: italic;
  }

  /* New styles for perks section */
  .perks-section {
    margin-top: 2rem;
  }

  .perks-section h3 {
    font-size: 1.4rem;
    color: #333;
    margin-bottom: 1.5rem;
    font-weight: 600;
    text-align: center;
  }

  .perks-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    justify-content: center; /* centers the grid items */
    gap: 1.5rem;
    margin-top: 1rem;
  }

  .perk-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

.perk-image {
  width: 140px;     /* keep container size */
  height: 160px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 0.75rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  /* Remove flex centering */
  display: block;
}

.perk-image img {
  width: 100%;      /* fill container width */
  height: 100%;     /* fill container height */
  object-fit: unset; /* remove cover/contain */
  display: block;
}

  .perk-label {
    font-size: 0.9rem;
    color: #555;
    text-align: center;
    line-height: 1.3;
  }
  
  .benefits-link {
    display: inline-block;
    margin-top: 1.5rem;
    color: #6F263D;
    font-weight: 600;
    text-decoration: none;
    font-size: 1rem;
    transition: all 0.2s ease;
  }
  
  .benefits-link:hover {
    text-decoration: underline;
    transform: translateX(3px);
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    max-width: 800px;
    margin-bottom: 2rem;
    margin-left: auto;
    margin-right: auto;
  }

  .primary-button {
    background-color: #6F263D;
    color: white;
    border: none;
    padding: 1rem 2rem;
    font-size: 1.1rem;
    border-radius: 30px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    text-decoration: none;
    display: inline-block;
    text-align: center;
  }

  .primary-button:hover {
    background-color: #6d0030;
  }

  .secondary-button {
    background-color: white;
    color: #6F263D;
    border: 2px solid #6F263D;
    padding: 1rem 2rem;
    font-size: 1.1rem;
    border-radius: 30px;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: none;
    display: inline-block;
    text-align: center;
  }

  .secondary-button:hover {
    background-color: rgba(134, 0, 56, 0.05);
  }

  .success-message {
    background-color: #e8f5e9;
    border-radius: 8px;
    padding: 1rem;
    color: #2e7d32;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }

  .tertiary-button {
    background-color: white;
    color: #333;
    border: 1px solid #ccc;
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    border-radius: 30px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: 1rem; /* Add spacing from other buttons */
    width: 100%; /* Make it full width for better separation */
  }

  .tertiary-button:hover {
    background-color: #f5f5f5;
    color: #6F263D; /* Cavs wine color on hover */
    border-color: #6F263D;
  }

  /* Smaller screens - maintain horizontal layout */
  @media (max-width: 768px) {
    .results-page {
      padding: 1rem;
    }

    .hide-on-mobile {
    display: none !important;
  }
    
  .image-gallery {
    justify-content: center !important;
  }

    /* Make the single visible image bigger on mobile */
  .gallery-image {
    width: 85% !important;
    max-width: 350px !important;
    height: auto !important;
    aspect-ratio: 3/2; /* Maintain aspect ratio */
  }

    .primary-button,
    .secondary-button,
    .tertiary-button {
      flex: 0 1 auto;
    }

    .action-buttons {
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
    }
    
    /* Mobile call button adjustments */
    .call-button {
      flex-direction: column;
      padding: 1rem;
    }
    
    .call-icon {
      margin-right: 0;
      margin-bottom: 0.5rem;
    }
    
    .call-text {
      text-align: center;
    }
    
    .call-primary-text {
      margin-bottom: 0.25rem;
    }

    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1.5rem;
    }

    .detail-row {
      flex-direction: column;
    }

    .detail-label {
      margin-bottom: 0.5rem;
    }

    .perks-grid {
      grid-template-columns: 1fr; /* Stack items vertically */
      max-width: 250px; /* More compact width */
      margin-left: auto;
      margin-right: auto;
      gap: 1rem; /* Reduced gap between items */
    }
    
    .perk-item {
      margin-bottom: 0.75rem; /* Reduced spacing between items */
    }
    
    .perk-image {
      height: 110px; /* Smaller images on mobile */
    }
    
    
    .perk-label {
      font-size: 0.9rem; /* Slightly smaller text */
      margin-top: 0.25rem; /* Less space between image and text */
    }
    
    .perks-section h3 {
      font-size: 1.2rem; /* Smaller heading */
      margin-bottom: 1rem; /* Less space below heading */
    }
    
    /* Optional: Adjust the "Explore all benefits" link */
    .benefits-link {
      margin-top: 0.75rem;
      font-size: 0.9rem;
    }
  }

    .early-bird-countdown {
      text-align: center;
      margin-bottom: 0.75rem;
    }

    .early-bird-label {
      font-size: 1.05rem;   /* larger */
      font-weight: 700;     /* bold */
      color: #444;
      margin-bottom: 0.25rem;
      display: block;
    }

    .early-bird-timer {
      font-size: 1.75rem;
      font-weight: 700;
      color: #6F263D; /* 🎯 countdown color */
    }

    /* Pricing section */
    .recommendation-details .detail-value {
      font-size: 1rem; /* base size, matches other detail text */
      color: #000;     /* default text color */
    }

    .recommendation-details .detail-value .old-price {
      color: red;
      text-decoration: line-through;
      margin-right: 0.25rem;
    }

    .recommendation-details .detail-value .current-price-number {
      font-weight: bold;
    }
    /* Pricing display styles */
    .pricing-display {
      display: flex;
      flex-direction: row; /* horizontal layout */
      gap: 0.5rem;         /* space between "$14/per game" and "Or from $168…" */
      flex-wrap: wrap;     /* wrap on very small screens */
      align-items: baseline;
    }

    .monthly-pricing,
    .seat-pricing {
      display: inline-block; /* makes them truly inline without line breaks */
      line-height: 1.5;
      white-space: nowrap;   /* prevent unwanted wrap */
    }

    .old-price {
      text-decoration: line-through;
      color: #888;
      margin-right: 0.25rem;
      font-size: 1.1 em;
      font-weight: bold;
    }

    .current-price-number {
      font-weight: bold;
      color: #000; /* Highlight new price */
      font-size: 1.1em;
    }

    /* Mobile responsiveness for pricing */
    @media (max-width: 768px) {
      .pricing-display {
        font-size: 0.95rem;
      }
      
      .monthly-pricing,
      .seat-pricing {
        line-height: 1.4;
      }
    }

    .added-value-row {
      grid-template-columns: 1fr; /* override the 2-column layout */
      text-align: center; 
    }

  /* Very small screens - stack images vertically */
  @media (max-width: 480px) {
    .image-gallery {
      flex-direction: column !important;
      align-items: center !important;
    }
    
    .gallery-image {
      width: 100% !important;
      max-width: 350px !important;
      height: auto !important;
      aspect-ratio: 3/2;
    }
  }
</style>
